import PropTypes from "prop-types";
import { forwardRef } from "react";
// @mui
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
// routes
import { RouterLink } from "src/routes/components";
// image
import Image from "../image";

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, sx, mini, invertLogo, ...other }, ref) => {
    const logo = (
        <Box
            ref={ ref }
            component="div"
            sx={ {
                width: "fit-content",
                height: 40,
                display: "inline-flex",
                ...sx
            } }
            { ...other }
        >
            {/* eslint-disable-next-line no-nested-ternary */ }
            { mini ? (
                <Image src="/assets/icon/navbar/ic_logo.svg" alt="logo" width={ 29 } height={ 29 } objectFit="contain" sx={ { flexShrink: 0, my: "auto", mr: "auto" } } disabledEffect visibleByDefault />
            ) : invertLogo ? (
                <Image src="/assets/icon/navbar/ic_logo_api_white.svg" alt="logo" width="auto" height={ 29 } objectFit="contain" sx={ { flexShrink: 0, maxWidth: 190, my: "auto", mr: "auto" } } disabledEffect visibleByDefault />
            ) : (
                <Image src="/assets/icon/navbar/ic_logo_api.svg" alt="logo" width="auto" height={ 29 } objectFit="contain" sx={ { flexShrink: 0, maxWidth: 190, my: "auto", mr: "auto" } } disabledEffect visibleByDefault />
            ) }
        </Box>
    );

    if (disabledLink) {
        return logo;
    }

    return (
        <Link component={ RouterLink } href="/" sx={ { display: "contents" } }>
            { logo }
        </Link>
    );
});

Logo.propTypes = {
    disabledLink: PropTypes.bool,
    sx: PropTypes.object,
    mini: PropTypes.bool,
    invertLogo: PropTypes.bool
};

export default Logo;
